const storage = {
	prefix: 'rbVideoPlayer_',
	get(key, def = null) {
		let data = localStorage.getItem(this.prefix + key);
		return data ? JSON.parse(data) : def;
	},
	set(key, val) {
		localStorage.setItem(this.prefix + key, JSON.stringify(val));
	}
};

export const VideoSettings = {
	get volume() {
		return storage.get('volume', 1);
	},
	set volume(val) {
		storage.set('volume', val);
	},

	get muted() {
		return storage.get('muted', false);
	},
	set muted(val) {
		storage.set('muted', val);
	},

	get size() {
		return storage.get('size', 480);
	},
	set size(val) {
		storage.set('size', val);
	},

	get skipOpening() {
		return storage.get('skipOpening', false);
	},
	set skipOpening(val) {
		storage.set('skipOpening', val);
	},

	get skipEnding() {
		return storage.get('skipEnding', true);
	},
	set skipEnding(val) {
		storage.set('skipEnding', val);
	},

	get autoPlay() {
		return storage.get('autoPlay', true);
	},
	set autoPlay(val) {
		storage.set('autoPlay', val);
	},
};